import Home from "./pages/home";
import Search from "./pages/search";
import About from "./pages/about";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Property from "./pages/property";
import ScrollToTop from "./components/ScrollToTop";
import { Header, Footer } from "./components/layout";
import { ChatProvider, AuthProvider } from "./providers";
import ChatWidget from "./components/chatbot/chat-widget";
import { Login, Register, Profile } from "./pages/auth";
import OAuthCallback from "./pages/auth/OAuthCallback";
import CompleteProfile from "./components/CompleteProfile";
import { ProtectedRoute, AdminRoute, InvestorRoute } from "./components/auth";
import { AdminLayout } from "./components/layout/AdminLayout";
import Unauthorized from "./pages/Unauthorized";
import MyQueries from "./pages/queries/MyQueries";
import QueryDetail from "./pages/queries/QueryDetail";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminQueries from "./pages/admin/queries/AdminQueries";
import AdminQueryDetail from "./pages/admin/queries/AdminQueryDetail";
import CalculationEditor from "./pages/admin/calculations/CalculationEditor";
import {
  AdminInvestments,
  AdminInvestmentDetail,
} from "./pages/admin/investments";
import { AdminUsers } from "./pages/admin/users";
import AdminDealFinder from "./pages/admin/AdminDealFinder";
import AdminReports from "./pages/admin/reports/AdminReports";
import Opportunities from "./pages/investor/Opportunities";
import OpportunityDetail from "./pages/investor/OpportunityDetail";
import MyInvestments from "./pages/investor/MyInvestments";
import InvestmentDetail from "./pages/investor/InvestmentDetail";
import { Toaster } from "./components/ui/sonner";
function AppShell() {
  const location = useLocation();
  const hideAppHeader = location.pathname === "/";

  return (
    <div className="flex flex-col min-h-screen">
      {!hideAppHeader && <Header />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/complete-profile"
            element={
              <ProtectedRoute>
                <CompleteProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/search"
            element={
              <ProtectedRoute>
                <Search />
              </ProtectedRoute>
            }
          />
          <Route
            path="/property/:propertyId"
            element={
              <ProtectedRoute>
                <Property />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-queries"
            element={
              <ProtectedRoute>
                <MyQueries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/queries/:queryId"
            element={
              <ProtectedRoute>
                <QueryDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="queries" element={<AdminQueries />} />
            <Route path="queries/:queryId" element={<AdminQueryDetail />} />
            <Route path="calculations/new/:queryId" element={<CalculationEditor />} />
            <Route path="calculations/:calcId" element={<CalculationEditor />} />
            <Route path="investments" element={<AdminInvestments />} />
            <Route path="investments/:commitmentId" element={<AdminInvestmentDetail />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="deal-finder" element={<AdminDealFinder />} />
            <Route path="reports" element={<AdminReports />} />
          </Route>
          <Route
            path="/opportunities"
            element={
              <InvestorRoute>
                <Opportunities />
              </InvestorRoute>
            }
          />
          <Route
            path="/opportunities/:queryId"
            element={
              <InvestorRoute>
                <OpportunityDetail />
              </InvestorRoute>
            }
          />
          <Route
            path="/my-investments"
            element={
              <InvestorRoute>
                <MyInvestments />
              </InvestorRoute>
            }
          />
          <Route
            path="/investments/:commitmentId"
            element={
              <InvestorRoute>
                <InvestmentDetail />
              </InvestorRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <Router>
          <ScrollToTop />
          <AppShell />
          <ChatWidget />
          <Toaster />
        </Router>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;
